import React from "react";
import { BoxStyled } from "./BoxStyled";
import { BoxProps } from "../../entities/Box";

const Box: React.FC<BoxProps> = ({ children, className }: BoxProps) => (
  <BoxStyled className={className}>{children}</BoxStyled>
);

export default Box;
